import { render, staticRenderFns } from "./PlotRecommenderTrailerModal.vue?vue&type=template&id=81a35baa"
import script from "./PlotRecommenderTrailerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommenderTrailerModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports